"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.allBosses = void 0;
const Bryophyta_1 = __importDefault(require("./Bryophyta"));
const CommanderZilyana_1 = __importDefault(require("./CommanderZilyana"));
const DagannothPrime_1 = __importDefault(require("./DagannothPrime"));
const DagannothRex_1 = __importDefault(require("./DagannothRex"));
const DagannothSupreme_1 = __importDefault(require("./DagannothSupreme"));
const GeneralGraardor_1 = __importDefault(require("./GeneralGraardor"));
const GiantMole_1 = __importDefault(require("./GiantMole"));
const KalphiteQueen_1 = __importDefault(require("./KalphiteQueen"));
const Kreearra_1 = __importDefault(require("./Kreearra"));
const KrilTsutsaroth_1 = __importDefault(require("./KrilTsutsaroth"));
const Obor_1 = __importDefault(require("./Obor"));
const Sarachnis_1 = __importDefault(require("./Sarachnis"));
const Skotizo_1 = __importDefault(require("./Skotizo"));
const slayer_1 = require("./slayer");
const Vorkath_1 = __importDefault(require("./Vorkath"));
const wildy_1 = require("./wildy");
const CorporealBeast_1 = __importDefault(require("./wildy/CorporealBeast"));
const Zulrah_1 = __importDefault(require("./Zulrah"));
exports.allBosses = Object.assign(Object.assign({ CorporealBeast: CorporealBeast_1.default,
    DagannothPrime: DagannothPrime_1.default,
    DagannothRex: DagannothRex_1.default,
    DagannothSupreme: DagannothSupreme_1.default,
    GiantMole: GiantMole_1.default,
    KalphiteQueen: KalphiteQueen_1.default,
    Obor: Obor_1.default,
    Sarachnis: Sarachnis_1.default,
    Vorkath: Vorkath_1.default,
    Zulrah: Zulrah_1.default,
    CommanderZilyana: CommanderZilyana_1.default,
    GeneralGraardor: GeneralGraardor_1.default,
    Kreearra: Kreearra_1.default,
    KrilTsutsaroth: KrilTsutsaroth_1.default,
    Bryophyta: Bryophyta_1.default,
    Skotizo: Skotizo_1.default }, wildy_1.allWildyBosses), slayer_1.allSlayerBosses);
//# sourceMappingURL=index.js.map